<template>
	<div>
		<div>
			<a-select  style="width:55%;margin-bottom: 0.625rem;font-size: 0.6875rem;" v-model="theLou"
				:allowClear="true" mode="multiple" placeholder="根据楼号选择用户" @change="handleChange">
				<a-select-option v-for="(item,index) in louList" :key="item.lou" :value="item.lou">{{item.lou}}</a-select-option>
			</a-select>
			<a-button  @click="doCheckByLou()" style="margin: 0 0.9375rem">确定</a-button>
			<span>共选择了{{selectedCustomerKeys.length}}个用户</span>
		</div>
		<vxe-table  align="center" :data="customerList"  border max-height="600"  :cell-style="cellClassName" ref="mTable" show-overflow="title" size="mini" stripe
						  resizable  :loading="loading"  @checkbox-all="selectAllEvent" @checkbox-change="selectChangeEvent"
						  :sort-config="{multiple: true,trigger: 'cell'}" :checkbox-config="{trigger: 'row', highlight: true, range: true}"  row-id="pId">
			<vxe-table-column type="seq" width="50"></vxe-table-column>
			<vxe-table-column type="checkbox" width="50"></vxe-table-column>
			<vxe-table-column title="用户号" field="customerNum"></vxe-table-column>
			<vxe-table-column title="用户名" field="customerName"></vxe-table-column>
			<vxe-table-column title="手机" field="customerMobile"></vxe-table-column>
			<vxe-table-column title="地址" field="customerAddr"></vxe-table-column>
		</vxe-table>
		<div class="drawerFooter">
		    <a-button icon="close" @click="onClose()" style="margin-right: 0.625rem;">取 消</a-button>
		    <a-button  icon="check" type="primary"  @click="onSubmit" :loading="submitloading">提 交</a-button>
		</div>
	</div>
</template>

<script>
	export default{
		props:[
			'neighborId',
		],
		data(){
			return{
				submitloading:false,
				loading:false,
				customerList:[],
				selectedCustomerList:[],
				selectedCustomerKeys:[],
				louList:[],
				theLou:undefined,
			}
		},
		methods:{
			cellClassName({ row, rowIndex, column }){
				let style = null;
				if(this.selectedCustomerKeys && this.selectedCustomerKeys.includes(row.pId)){
					style = {
						backgroundColor: '#FFE48A',
					}
				}else{
					style = {
							'color':'#333',
							fontFamily:"arial,sans-serif"
					}	
				}	
				return style;
			},
			selectAllEvent ({ checked, records }) {
				if(checked){
					for(var i = 0;i<records.length;i++){
						this.selectedCustomerKeys.push(records[i].pId);
						this.selectedCustomerList.push(records[i]);
					}
				}else{
					this.selectedCustomerKeys = [];
					this.selectedCustomerList = [];
				}
			},
			selectChangeEvent({ checked, records }) {
				this.selectedCustomerKeys = [];
				this.selectedCustomerList = [];
				for(var i = 0;i<records.length;i++){
					this.selectedCustomerKeys.push(records[i].pId);
					this.selectedCustomerList.push(records[i]);
				}
			},
			handleChange:function(value){
				this.theLou = value;
			},
			doCheckByLou:function(){
				this.selectedCustomerList = [];
				this.selectedCustomerKeys =[];
				for(var i = 0;i<this.theLou.length;i++){
					var theLou = this.theLou[i];
					for(var j=0;j<this.customerList.length;j++){
						var customer = this.customerList[j];
						if(customer.louNum == theLou){
							if(this.selectedCustomerList.indexOf(customer)==-1){
								this.selectedCustomerList.push(customer);
							}
							if(this.selectedCustomerKeys.indexOf(customer.pId) ==-1){
								this.selectedCustomerKeys.push(customer.pId);
							}
						}
					}
				}
				if(this.selectedCustomerKeys.length){
					this.$refs.mTable.setCheckboxRow(this.selectedCustomerList,true);
				}else{
					this.$refs.mTable.removeCheckboxRow();
				}
			},
			onClose:function(){
				this.$emit('onClose');
			},
			onSubmit:function(){
				this.submitloading = true;
				if(this.selectedCustomerList.length == 0){
					this.$message.error('请选择用户');
					this.submitloading = false;
				}else{
					this.$emit('onClose');
					this.$emit('checkChoosedCustomers',[this.neighborId,this.selectedCustomerList]);
					this.submitloading = false;
				}
			},
			queryCustomers:function(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_LIST_WITH_NEIGHBOR_URL);
				let param = {neighborId:this.neighborId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.customerList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			queryLous:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_LIST_LOU_URL);
				let param = {neighborId:this.neighborId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.louList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
		},
		created() {
			this.queryCustomers();
			this.queryLous();
		},
		computed:{
		}
	}
</script>

<style>
</style>
